var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"AppReviewReport my-4"},[(_vm.iframeUrl)?_c('iframe',{staticStyle:{"width":"100%","height":"100vh","border":"none"},attrs:{"src":_vm.iframeUrl,"sandbox":"allow-scripts allow-same-origin allow-popups allow-forms"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }